import { useQuery } from '@tanstack/react-query';

import { useRequest, queryClient, type QueryFunction } from '@frontend/api';

import type { SimilarPartResult } from './types';

export const getUseGetSimilaritySearchKey = (
  partUuid: string,
  partNumber?: string,
) => ['similaritySearch', partUuid, partNumber] as const;

export const useGetSimilaritySearch: QueryFunction<
  SimilarPartResult[],
  [string, string | undefined],
  ReturnType<typeof getUseGetSimilaritySearchKey>
> = (partUuid, partNumber, { queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseGetSimilaritySearchKey(partUuid ?? '', partNumber),
    queryFn: ({ signal }) => {
      return request<SimilarPartResult[]>(
        `/parts/${partUuid}/similarity_search`,
        {
          init: {
            method: 'POST',
            body: partNumber ? { partNumber } : {},
            signal,
          },
        },
      );
    },
  });
};

export const invalidateSimilaritySearchQuery = (partUuid: string) => {
  queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey[0] === 'similaritySearch' &&
      query.queryKey[1] === partUuid,
  });
};
